import { Html, useGLTF } from "@react-three/drei";
import React, { useRef } from "react";
import { saturnClicked } from "../../redux/saturnClickSlice";
import PlanetText from "../planetText/PlanetText";
import { useFrame } from "@react-three/fiber";
import { gsap } from "gsap";

const SaturnModel = (props) => {
    const {
        camera,
        dispatch,
        isSaturnClicked,
        isEarthClicked,
        isJupiterClicked,
        isUranusClicked,
        isExploreButtonClicked,
        saturnInitialValue,
        jupiterInitialValue,
        earthInitialValue,
    } = props;

    const Saturn = useGLTF("./assets/saturno.glb");
    const SaturnModelRef = useRef();

    const SaturnModelClick = (event) => {
        dispatch(saturnClicked());

        console.log(SaturnModelRef);
        event.stopPropagation();
    };

    useFrame((state) => {
        const returnInitialPosition = () => {
            gsap.to(SaturnModelRef.current.position, {
                x: () => -4,
                y: () => -0.6,
                z: () => 0,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].rotation, {
                x: () => 0,
                y: () => 0,
                z: () => -0.4,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].scale, {
                x: () => 0.01,
                y: () => 0.01,
                z: () => 0.01,
                duration: 2,
            });
        };
        if (
            isSaturnClicked === true &&
            isEarthClicked === false &&
            saturnInitialValue !== 0 &&
            isJupiterClicked === false &&
            isUranusClicked === false
        ) {
            gsap.to(SaturnModelRef.current.position, {
                x: () => 2.5,
                y: () => -1.3,
                z: () => 1.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].rotation, {
                x: () => 3.2,
                y: () => 0.5,
                z: () => 2.6,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].scale, {
                x: () => 0.018,
                y: () => 0.018,
                z: () => 0.018,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[1].position, {
                x: () => 0.3,
                y: () => 1.3,
                z: () => 0,
                duration: 2,
            });
        }
        if (
            isSaturnClicked === false &&
            saturnInitialValue !== 0 &&
            isEarthClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (isEarthClicked === true) {
            gsap.to(SaturnModelRef.current.position, {
                x: () => -4.5,
                y: () => -2,
                z: () => 1.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].rotation, {
                x: () => 0,
                y: () => 0.8,
                z: () => 2.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].scale, {
                x: () => 0.005,
                y: () => 0.005,
                z: () => 0.005,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[1].position, {
                x: () => 1,
                y: () => 0,
                z: () => 0.0,
                duration: 2,
            });
        }
        if (
            isEarthClicked === false &&
            earthInitialValue !== 0 &&
            isSaturnClicked === false &&
            isJupiterClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (
            isJupiterClicked === true &&
            isEarthClicked === false &&
            isSaturnClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            gsap.to(SaturnModelRef.current.position, {
                x: () => -4.5,
                y: () => -2,
                z: () => 1.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].rotation, {
                x: () => 0,
                y: () => 0.8,
                z: () => 2.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].scale, {
                x: () => 0.005,
                y: () => 0.005,
                z: () => 0.005,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[1].position, {
                x: () => 1,
                y: () => 0,
                z: () => 0.0,
                duration: 2,
            });
        }
        if (
            isJupiterClicked === false &&
            isEarthClicked === false &&
            jupiterInitialValue !== 0 &&
            isSaturnClicked === false &&
            isUranusClicked === false &&
            isExploreButtonClicked === true
        ) {
            returnInitialPosition();
        }
        if (
            isUranusClicked === true &&
            isJupiterClicked === false &&
            isEarthClicked === false &&
            isSaturnClicked === false &&
            isExploreButtonClicked === true
        ) {
            gsap.to(SaturnModelRef.current.position, {
                x: () => -4.5,
                y: () => -2,
                z: () => 1.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].rotation, {
                x: () => 0,
                y: () => 0.8,
                z: () => 2.5,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[0].scale, {
                x: () => 0.005,
                y: () => 0.005,
                z: () => 0.005,
                duration: 2,
            });
            gsap.to(SaturnModelRef.current.children[1].position, {
                x: () => 0.9,
                y: () => -0.1,
                z: () => 0.0,
                duration: 2,
            });
        }
    });
    return (
        <group
            position={[-4, -0.6, 0]}
            onClick={SaturnModelClick}
            onPointerEnter={() => (document.body.style.cursor = "pointer")}
            onPointerLeave={() => (document.body.style.cursor = "default")}
            ref={SaturnModelRef}
            visible={isExploreButtonClicked ? true : false}
        >
            <primitive object={Saturn.scene} scale={0.01} rotation={[0, 0, -0.4]} />

            <Html position={[0.8, 0.7, 0]}>
                <PlanetText content={"What we do"} isExploreButtonClicked={isExploreButtonClicked} />
            </Html>
        </group>
    );
};

export default SaturnModel;
